module.exports = __webpack_public_path__ + "img/hunter.825f7814.png";